package de.connect2x.timmy.customcomponents.roomHeaderWithArchiveButton

import de.connect2x.trixnity.core.model.RoomId
import de.connect2x.trixnity.messenger.extensions.tim.roomdetails.TIMRoomHeaderViewModel
import de.connect2x.trixnity.messenger.viewmodel.MatrixClientViewModelContext
import de.connect2x.trixnity.messenger.viewmodel.ViewModelContext

class RoomHeaderWithArchiveButtonViewModelWcImpl(
    private val viewModelContext: MatrixClientViewModelContext,
    private val selectedRoomId: RoomId,
    timRoomHeaderViewModel: TIMRoomHeaderViewModel,
) :
    RoomHeaderWithArchiveButtonViewModelWcI, ViewModelContext by viewModelContext,
    TIMRoomHeaderViewModel by timRoomHeaderViewModel {

    override fun fetchViewModelContextAndRoomId(): Pair<MatrixClientViewModelContext, RoomId> {
        return Pair(viewModelContext, selectedRoomId)
    }
}

